// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JxHa","input":"styles_input__1nyV6"};